<template>
  <div>
    <TemplateCard
      v-loading="loading"
      :data="data"
      @confirm="(e) => $emit('confirm', e)"
    />
    <div class="d-flex justify-content-between mt-3 mb-2">
      <pagination
        size="small"
        align="right"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="onPaginationChange"
      />
      <div class="d-flex justify-content-center align-items-center">
        <el-button size="small" @click="$emit('close')">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateCard from './template-card.vue'
export default {
  components: { TemplateCard },
  props: { templateGroup: { type: String, default: '' } },
  data() {
    return {
      data: [],
      loading: false,
      page: { curPage: 1, pageSize: 20, pageTotal: 0 },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.templateGroup) {
        throw new Error('props [templateGroup] is null')
      }

      const params = { templateGroupList: [this.templateGroup], ...this.page }
      this.loading = true
      const res = await this.$api
        .sysInoutTemplateListApi(params)
        .catch(() => null)
      this.loading = false
      if (!res || !res.body) return
      this.data = res.body.data
      this.page.pageTotal = res.body.count
      this.page.pageSize = res.body.pageSize
      this.page.curPage = res.body.curPage
    },
    onPaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.getData()
    },
  },
}
</script>
